(() => {
  const namespace = 'ProlabScrollReveal';

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  const selector = '[data-prolab-reveal]';
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const observedElements = new Set();

  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  const completeReveal = (element) => {
    element.dataset.prolabRevealComplete = 'true';
    element.removeAttribute('data-prolab-reveal-initialized');
    element.classList.remove('is-prolab-revealed');
    element.style.removeProperty('--prolab-reveal-delay');
    element.style.removeProperty('--prolab-reveal-duration');
  };

  const reveal = (element) => {
    observer.unobserve(element);
    observedElements.delete(element);

    if (reducedMotionQuery.matches) {
      completeReveal(element);
      return;
    }

    element.classList.add('is-prolab-revealed');
    const delay = clamp(Number(element.dataset.prolabDelay) || 0, 0, 1000);
    const duration = clamp(Number(element.dataset.prolabDuration) || (mobileQuery.matches ? 720 : 820), 300, 1400);
    let completed = false;

    const finish = () => {
      if (completed) return;
      completed = true;
      element.removeEventListener('transitionend', onTransitionEnd);
      completeReveal(element);
    };

    const onTransitionEnd = (event) => {
      if (event.target !== element || (event.propertyName !== 'opacity' && event.propertyName !== 'transform')) return;
      finish();
    };

    element.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finish, delay + duration + 100);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) reveal(entry.target);
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -8% 0px',
  });

  const initElement = (element) => {
    if (
      element.dataset.prolabRevealInitialized === 'true' ||
      element.dataset.prolabRevealComplete === 'true' ||
      element.closest('.prolab-hero')
    ) return;

    const delay = clamp(Number(element.dataset.prolabDelay) || 0, 0, 1000);
    const duration = clamp(Number(element.dataset.prolabDuration) || (mobileQuery.matches ? 720 : 820), 300, 1400);
    element.dataset.prolabRevealInitialized = 'true';
    element.style.setProperty('--prolab-reveal-delay', `${delay}ms`);
    element.style.setProperty('--prolab-reveal-duration', `${duration}ms`);

    if (reducedMotionQuery.matches) {
      completeReveal(element);
      return;
    }

    observedElements.add(element);
    observer.observe(element);
  };

  const init = (root = document) => {
    if (root.matches?.(selector)) initElement(root);
    root.querySelectorAll?.(selector).forEach(initElement);
  };

  const destroy = (root) => {
    const elements = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    elements.forEach((element) => {
      observer.unobserve(element);
      observedElements.delete(element);
    });
  };

  reducedMotionQuery.addEventListener('change', () => {
    if (!reducedMotionQuery.matches) return;
    [...observedElements].forEach(reveal);
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window[namespace] = { init, destroy };
  init(document);
})();
